import { SendConversationTechnicalMessageUseCase } from './SendConversationTechnicalMessageUseCase'
import { conversationRepository } from '../../../data-access/repositories'

export const sendConversationTechnicalMessage =
  new SendConversationTechnicalMessageUseCase({
    conversationRepository,
  }).execute
